'use client';
import AchievementsList from '@/components/Achievements/AcievementsCards/AchievementsList';
import { useState, ReactNode } from 'react';
import ModalFormMC from '../Modal/ModalMC';
import { SerializedEditorState } from 'node_modules/lexical/LexicalEditorState';
import CustomRichText from '../CustomRichText';

export interface AchievementsBlockCustomProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  showBtn?: boolean;
  btnText?: string;
  achievementsList: Array<{
    icon?: string | { url: string; alt: string };
    width?: number;
    height?: number;
    title: ReactNode | SerializedEditorState;
    subtitle: ReactNode | SerializedEditorState;
  }>;
}
export default function AchievementsBlockCustom({
  title,
  achievementsList,
  subtitle,
  id,
  showBtn,
  btnText,
  title_2,
}: AchievementsBlockCustomProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);
  return (
    <>
      <div
        id={id}
        data-meta="AchievementsBlockCustom"
        className="flex flex-col gap-x-4 justify-center container mx-auto sm:px-6 lg:px-8 mt-16 xl:mb-24"
        meta-data="AchievementsBlockCustom"
      >
        <div className="container mx-auto px-4 py-6 sm:py-4 sm:px-6 lg:px-8">
          <div className="mx-auto text-center">
            <CustomRichText
              data={title}
              tag="h2"
              className="text-4xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
            />
            {subtitle && (
              <CustomRichText
                data={subtitle}
                tag="div"
                className="mt-6 text-md lg:text-xl md:leading-6 lg:leading-8 text-white"
              />
            )}
          </div>
        </div>
        {title_2 && (
          <CustomRichText
            data={title_2}
            tag="div"
            className="text-xl text-center font-bold tracking-tight text-white sm:text-2xl mb-4 sm:mb-8"
          />
        )}
        <AchievementsList achievementsList={achievementsList} />
        {showBtn && (
          <div className="flex justify-center mt-8">
            <button
              onClick={openForm}
              className="custom-gradient-green-btn rounded-full px-8 py-2.5 text-center text-md font-fixel font-bold text-white shadow-sm focus-visible:outline"
            >
              {btnText}
            </button>
          </div>
        )}
      </div>
      {isFormOpen && (
        //works only with marketing in CRM
        <ModalFormMC
          closeForm={closeForm}
          btnMeta={{
            tag: 'партнерська-програма',
          }}
          color={'green'}
        />
      )}
    </>
  );
}
